import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "legacy-change-logs",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#legacy-change-logs",
        "aria-label": "legacy change logs permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Legacy Change Logs`}</h1>
    <h2 {...{
      "id": "990-2021-02-04",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#990-2021-02-04",
        "aria-label": "990 2021 02 04 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.8.0...v9.9.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.9.0`}</a>{` (2021-02-04)`}</h2>
    <h3 {...{
      "id": "bug-fixes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes",
        "aria-label": "bug fixes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`add DistributionSelect i18n, fix Emails i18n (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8099",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8099`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0118df30125fb6b9fa435b834ebeeb106c2afae2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0118df3`}</a>{`)`}</li>
      <li parentName="ul">{`cleanup of dom attributes (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8121",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8121`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dac84f5b0fc9b266d72e2d0266b788d558c46581",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dac84f5`}</a>{`)`}</li>
      <li parentName="ul">{`imports for Panel component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8128",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8128`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a397aef5b5bcf9bda42de5db5f69f07f5a7d447f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a397aef`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features",
        "aria-label": "features permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`change ContactItem design (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8098",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8098`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b4b10bf4f3182e7bfa3571cdecd410b188bb1f2e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b4b10bf`}</a>{`)`}</li>
      <li parentName="ul">{`Expose Typography component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8124",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8124`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b3ff62ac7334e49627c982bac893513c1219a40e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b3ff62a`}</a>{`)`}</li>
      <li parentName="ul">{`FlexList space prop, accurate mapping of the space palette (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8095",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8095`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2977233c70f626c26715db30e88d4e03457f6450",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2977233`}</a>{`)`}</li>
      <li parentName="ul">{`Introduce Panel component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8013",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8013`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f68cbe2a8676b1ec1f865e6980d41180628d4448",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f68cbe2`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "980-2021-01-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#980-2021-01-29",
        "aria-label": "980 2021 01 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.7.0...v9.8.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.8.0`}</a>{` (2021-01-29)`}</h2>
    <h3 {...{
      "id": "bug-fixes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-1",
        "aria-label": "bug fixes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`tooltip content wrapping (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8071",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8071`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b1d2a08ed73d13b85538a1c1f8c1b82e5b779292",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b1d2a08`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-1",
        "aria-label": "features 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2896]`}{` Required Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8044",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8044`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/80182c854692b8131ef07e9fc8c6323732295e78",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`80182c8`}</a>{`)`}</li>
      <li parentName="ul">{`adding in shadow palette mixin (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8082",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8082`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4783444009bd2a2d6788ed5ff4084f9563115210",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4783444`}</a>{`)`}</li>
      <li parentName="ul">{`Translation Delivery from Smartling 26 Jan 2021 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8084",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8084`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/725d4caaded31f6eb284cc7204f098249dd54724",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`725d4ca`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "970-2021-01-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#970-2021-01-16",
        "aria-label": "970 2021 01 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.6.0...v9.7.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.7.0`}</a>{` (2021-01-16)`}</h2>
    <h3 {...{
      "id": "bug-fixes-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-2",
        "aria-label": "bug fixes 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2878][glue-2879]`}{` - Fix GroupSelect issues (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7995",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7995`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e78c51a105334ad36a3b997a4b9cec2b99407712",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e78c51a`}</a>{`)`}</li>
      <li parentName="ul">{`Change DropdownFlyout to close on click rather than mousedown (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8022",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8022`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ccf5891d78192bf39bffdb95e119ecdfc2150092",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ccf5891`}</a>{`)`}</li>
      <li parentName="ul">{`fix typo in NumberInput styles (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8067",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8067`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7c8ea12effce0e3905308549907adad33e7c3ebb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7c8ea12`}</a>{`)`}</li>
      <li parentName="ul">{`form in modal allow single left item (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8051",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8051`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/12471e80dc0fec00cda0fc43e0c1bc444b009d84",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`12471e8`}</a>{`)`}</li>
      <li parentName="ul">{`set default for selectableTiers to true (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8065",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8065`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/73648967e09670513b2834e57fb79c0823b536ba",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7364896`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` this fixes tiered select onClear bug by adding onClear to the provider. Also adds a (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8032",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8032`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fe2aed0f74c3b9f7b6a6c07461ce38b250c77ff4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fe2aed0`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8011",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8011`}</a></li>
    </ul>
    <h3 {...{
      "id": "features-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-2",
        "aria-label": "features 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[CTEF-218]`}{` add translations for DataTable (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8007",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8007`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/71b69e4f9a562cf2d0a99b84cdca051f8c70dd7a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`71b69e4`}</a>{`)`}</li>
      <li parentName="ul">{`add translations for connected emails (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8053",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8053`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/92212f4af5c8890089bc2d95bed9700fe9fbe4e9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`92212f4`}</a>{`)`}</li>
      <li parentName="ul">{`convert NumberInput component to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7957",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7957`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0b21cb202962a4e07cbdc49ff05f5ef89691d170",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0b21cb2`}</a>{`)`}</li>
      <li parentName="ul">{`make FileSelect.GridSource JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7912",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7912`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3df01b3731b316d89465c07850aee765c688398e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3df01b3`}</a>{`)`}</li>
      <li parentName="ul">{`Update Translation Files (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8031",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8031`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0945c56201dd9852df9b46a4165a4bf19ef60022",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0945c56`}</a>{`)`}</li>
      <li parentName="ul">{`Update Translation Files (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8060",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8060`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e95647d90fd5194897864a26c266b71071003790",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e95647d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` added always to tooltip trigger options (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8026",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8026`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2472edca82ec3f2c25b2ddd931f250a2b8d199d8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2472edc`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "960-2020-12-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#960-2020-12-18",
        "aria-label": "960 2020 12 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.5.0...v9.6.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.6.0`}</a>{` (2020-12-18)`}</h2>
    <h3 {...{
      "id": "bug-fixes-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-3",
        "aria-label": "bug fixes 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2643]`}{` Form wrap for run-on strings (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7970",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7970`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f1827b15a1a64f8a43008802ed12b7a29fa70390",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f1827b1`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2789]`}{` NumberInput. Cursor position improvements on text selection update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7911",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7911`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/76b84185fcee4c46dd2d709501fa3eeba5782551",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`76b8418`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2874]`}{` NumberInput. Incrementer works incorrect for fr, de and es locales (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7969",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7969`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ea3530600b9a89a93e16c0cbff65bf47bab0d90b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ea35306`}</a>{`)`}</li>
      <li parentName="ul">{`Dropzone error message remove unneeded sentence (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7976",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7976`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/92ccbda7d1f0a91aa273d3bf70e3bfcc3cb6de26",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`92ccbda`}</a>{`)`}</li>
      <li parentName="ul">{`Form Column and Specific Story for Word Wrap (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8002",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8002`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6b5ac1db228c955494a080d240060fb76c5b4651",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6b5ac1d`}</a>{`)`}</li>
      <li parentName="ul">{`Pill Select Selected Icon (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8003",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8003`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f633662a1803e588523d009b1c4cce9292fdc12a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f633662`}</a>{`)`}</li>
      <li parentName="ul">{`Typography styled component transient prop for color (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7990`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5ca1505f5189c05f5e2cf95b1b41686a08cd44e3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5ca1505`}</a>{`)`}</li>
      <li parentName="ul">{`WXP Detail Page allow action only layout with them on right (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/8004",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#8004`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/45c1ccfaf6214042cf6b68c18539297930587159",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`45c1ccf`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-3",
        "aria-label": "features 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2785]`}{` Flex reverse and some layout stories (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7928",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7928`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cf00b167409e89431ab18d63ab1f70cb66965ad7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cf00b16`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2778]`}{` Form and Sections No Max Width (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7876",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7876`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4307ccad1649a3a602ccca3474c04606e73c48f2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4307cca`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2812]`}{` - Convert Breadcrumbs to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7931",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7931`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f0a4b01f48314606444dbe6af6d1125aa6d0dd12",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f0a4b01`}</a>{`)`}</li>
      <li parentName="ul">{`convert ContactItem component to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7932",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7932`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b11e6e627b2f22b755f4d05d17508abf3e1c7852",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b11e6e6`}</a>{`)`}</li>
      <li parentName="ul">{`convert Pill component to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7961",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7961`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/212ff985ac90ba6eda88a1c103cfda2ea03d9920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`212ff98`}</a>{`)`}</li>
      <li parentName="ul">{`convert PillSelect component to JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7942",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7942`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0f9e4fbfb9a46b7052b66b2198cdfbb447d0b7ed",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0f9e4fb`}</a>{`)`}</li>
      <li parentName="ul">{`expose WXPDetailPageContext (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7999",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7999`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2cb8fc3ce1185359751d1ae8fdbdf1eb3450edf4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2cb8fc3`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts",
        "aria-label": "reverts permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`Revert "Revert "refactor: `}{`[GLUE-2792]`}{` - Banner Migration to JSS (#7906)" (#7949)" (#7950) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ec05fbeedd9d095d14a543f6a86d622b3d5d74c1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ec05fbe`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7906",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7906`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7949",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7949`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7950",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7950`}</a></li>
      <li parentName="ul">{`Revert "refactor: `}{`[GLUE-2792]`}{` - Banner Migration to JSS (#7906)" (#7949) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/697a10e8fbd6b2be45765d83d61ea09465e870f9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`697a10e`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7906",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7906`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7949",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7949`}</a></li>
    </ul>
    <h2 {...{
      "id": "950-2020-12-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#950-2020-12-03",
        "aria-label": "950 2020 12 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.4.0...v9.5.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.5.0`}</a>{` (2020-12-03)`}</h2>
    <h3 {...{
      "id": "bug-fixes-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-4",
        "aria-label": "bug fixes 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2806]`}{` Select Disabled when Ellipsis (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7922",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7922`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ffe27f261dfe8d793e761451cf8914b96d8472c7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ffe27f2`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2810]`}{` PillSelect disabled with value will not open (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7923",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7923`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bf47a3f0f041c29eec660e88252984bd8b8f4f69",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bf47a3f`}</a>{`)`}</li>
      <li parentName="ul">{`upgrade ramda from 0.27.0 to 0.27.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7902",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7902`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/df822d7171065f76ba5bca6b6b166c0821372e4b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`df822d7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` options being shown on disabled select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7889",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7889`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/585dd680314fff0a818f29ec27d88dbf9219c45e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`585dd68`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-4",
        "aria-label": "features 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2650]`}{` Generate React icons directly (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7716",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7716`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/26357ebb5a723af20e736a65a89c5ebe7c4bfd06",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`26357eb`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2752]`}{` Stop input after 15 digits for NumberInput, preventing precision drift (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7796",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7796`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5059ced114c00d89fba9f2eba804e0ed811d17ce",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5059ced`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2754][GLUE-2790]`}{` handle multiple dropzone errors (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7802",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7802`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/df3ab518663cb2f6a76683a88028a719af624251",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`df3ab51`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2866]`}{` Connected file select filters and empty state translations (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7935",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7935`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c176f3d7a8ce41dee68e954ab600511c12043539",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c176f3d`}</a>{`)`}</li>
      <li parentName="ul">{`introduce Thumbnail JSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7898",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7898`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fce4f17bb258bfd24fe236251a76fb67b6381f48",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fce4f17`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "940-2020-11-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#940-2020-11-23",
        "aria-label": "940 2020 11 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.3.0...v9.4.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.4.0`}</a>{` (2020-11-23)`}</h2>
    <h3 {...{
      "id": "bug-fixes-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-5",
        "aria-label": "bug fixes 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2753]`}{` - Fix Thumbnail List Focus (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7807",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7807`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/71de9f239bc4e56fd706fc194fa3d2d581493619",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`71de9f2`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2770]`}{` TinyMCE Bump (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7822",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7822`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a0c38641e71229ff324ea34d99230285cddcb67f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a0c3864`}</a>{`)`}</li>
      <li parentName="ul">{`Form Number and Currency 0 value (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7817",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7817`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6c57bae05029399ffdf2a9bf61ebeecdd17f7667",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6c57bae`}</a>{`)`}</li>
      <li parentName="ul">{`remove underline from tokens in file-select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7861",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7861`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/54819f327ee2f63e76485ba6baa189524b19c51f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`54819f3`}</a>{`)`}</li>
      <li parentName="ul">{`removing event journal, for real (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7857",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7857`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/759b4d96ad023ac32958d9b959d5f65d0ae85d89",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`759b4d9`}</a>{`)`}</li>
      <li parentName="ul">{`update comments to trigger builds (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7809",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7809`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/44c158a9ef12f045e5f90b1ad6b472c4c84a2b0f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`44c158a`}</a>{`)`}</li>
      <li parentName="ul">{`upgrade @testing-library/jest-dom from 5.11.4 to 5.11.5 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7878",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7878`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7a248fd27e8b8bcf59a53416e0ceb1e06e9dd00b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7a248fd`}</a>{`)`}</li>
      <li parentName="ul">{`upgrade axios from 0.19.2 to 0.21.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7847",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7847`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3a58fbd2929b6e8c71dac3ed6b7782f8a542f96e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3a58fbd`}</a>{`)`}</li>
      <li parentName="ul">{`upgrade date-fns from 2.10.0 to 2.16.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7844",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7844`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/86fe23406ada5b9b37b192a283619f7277551470",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`86fe234`}</a>{`)`}</li>
      <li parentName="ul">{`upgrade react-window from 1.8.5 to 1.8.6 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7877",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7877`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/de6c496d0e869ea5c906ae6a05a7f57f2ce3421b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`de6c496`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-5",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-5",
        "aria-label": "features 5 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2510]`}{` Spinner Update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7805",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7805`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ab3f78cc4b9dfcbcbc26765e31596c7a6962de8b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ab3f78c`}</a>{`)`}</li>
      <li parentName="ul">{`i18n connected file select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7808",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7808`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2029c976b445c94b9a1ba62b86d189cd70beff81",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2029c97`}</a>{`)`}</li>
      <li parentName="ul">{`Pagination handles Page label with i18n (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7793",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7793`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5eaf14c9215f5ff251a74f49ad5e9ea7c649899",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5eaf14`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "930-2020-11-06",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#930-2020-11-06",
        "aria-label": "930 2020 11 06 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.2.2...v9.3.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.3.0`}</a>{` (2020-11-06)`}</h2>
    <h3 {...{
      "id": "bug-fixes-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-6",
        "aria-label": "bug fixes 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2636]`}{` - Remove focus when pressing the clear button in IE 11 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7773",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7773`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c7becacf422ce2c6f30b7346766c7a3cd390f1dc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c7becac`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2722]`}{` - Keyboard Functionality in MenuFlyout (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7769",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7769`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5795aac9f0aee5ff618438827bd6cdf90bfd677",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5795aa`}</a>{`)`}</li>
      <li parentName="ul">{`Follow-up fixes for Pill Select component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7749",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7749`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/117c4fe3cc8c6c2f285a5ac739789795d78b4755",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`117c4fe`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-6",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-6",
        "aria-label": "features 6 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2287]`}{` Dirty form prevent navigation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7479",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7479`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6f185f07c4d63a8bf60509e8d82aafad9965e0d8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6f185f0`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1971]`}{` Form.PillSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7777",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7777`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0f129fad49449d30d92889a39a58c714372a91e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0f129fa`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2255]`}{` Form.Currency (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7782",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7782`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d1c94cd8e118417ce951cd54b24f22baf161bafa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d1c94cd`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2597]`}{` - Disabled state for MenuImperative.Item (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7786",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7786`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/474e94b8d7f040d8cd19bcc977ca014a0e6ff8af",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`474e94b`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2720]`}{` - Truncation Tooltip in Select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7759",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7759`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1ee15a51060e7e1ace2f5bacc47cb4609c5ea8cc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1ee15a5`}</a>{`)`}</li>
      <li parentName="ul">{`add QA tags to Core React Modal component for e2e testing (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7748",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7748`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/93027444949bc2efe3a2f7bc25f2ade13695937c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9302744`}</a>{`)`}</li>
      <li parentName="ul">{`change NumberInput behavior when fill decimal scale is set to always (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7774",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7774`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6026a10fd88c65a3ca3d09aecfb93ace24a0f1bb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6026a10`}</a>{`)`}</li>
      <li parentName="ul">{`Update Smartling translations (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7780",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7780`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/28bcc172bd972e28518eeb43db21ad4cc7d29b98",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`28bcc17`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "922-2020-10-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#922-2020-10-29",
        "aria-label": "922 2020 10 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.2.1...v9.2.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.2.2`}</a>{` (2020-10-29)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "921-2020-10-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#921-2020-10-29",
        "aria-label": "921 2020 10 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.2.0...v9.2.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.2.1`}</a>{` (2020-10-29)`}</h2>
    <h3 {...{
      "id": "bug-fixes-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-7",
        "aria-label": "bug fixes 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2660]`}{` Percy review followup (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7672",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7672`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/43d802bcc7ec4d32fdc454611bbb6a375b8048f5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`43d802b`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "920-2020-10-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#920-2020-10-27",
        "aria-label": "920 2020 10 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.1.0...v9.2.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.2.0`}</a>{` (2020-10-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-8",
        "aria-label": "bug fixes 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Modal classname change (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7735",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7735`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6a1ae319aea41655d61ff8c4586732285527e909",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6a1ae31`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-7",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-7",
        "aria-label": "features 7 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2598]`}{` - introduce Menu Flyout component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7660",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7660`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/53a776028eeb0d7ca1ad3fd21cb06935bda2f540",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`53a7760`}</a>{`)`}</li>
      <li parentName="ul">{`update stories and interfaces for Dropdown (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7725",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7725`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2fad95f4ea0382f88e1623caef17326a48aa64b4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2fad95f`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-1",
        "aria-label": "reverts 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`Revert "chore: `}{`[GLUE-2624]`}{` Swap out Nightmare for different test runner (#7679)" (#7742) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/77380065f6b252557ea2f3daddb52e1611d2c512",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7738006`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7679",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7679`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7742",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7742`}</a></li>
    </ul>
    <h2 {...{
      "id": "910-2020-10-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#910-2020-10-23",
        "aria-label": "910 2020 10 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v9.0.0...v9.1.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.1.0`}</a>{` (2020-10-23)`}</h2>
    <h3 {...{
      "id": "bug-fixes-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-9",
        "aria-label": "bug fixes 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2642]`}{` do not select FileExplorer's thumbnail item on its caption tooltip click (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7699",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7699`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/83f970e4dadcf6f0ed3dc778ce9d5408a05df02d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`83f970e`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2661]`}{` Update placeholder color on Typeahead (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7670",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7670`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b5e6c578471d8583ecca1d723f120c39d81f2946",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b5e6c57`}</a>{`)`}</li>
      <li parentName="ul">{`fix button blinking while loading files in local source tab (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7703",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7703`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9ca63293b104a2127837de0208842c795fcd1c2a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9ca6329`}</a>{`)`}</li>
      <li parentName="ul">{`fixed focus work after reopening file explorer (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7694",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7694`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/31cefccfe93a714a57fb5e78703faf0409820d78",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`31cefcc`}</a>{`)`}</li>
      <li parentName="ul">{`local source tab update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7713",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7713`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8da73efe0405c923091a47fe251f573000e8a8bf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8da73ef`}</a>{`)`}</li>
      <li parentName="ul">{`making Menu.Item `}<inlineCode parentName="li">{`item`}</inlineCode>{` prop optional (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7635",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7635`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4f47998a3acbf5deacdd08bf8f54cbf4054d21a1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4f47998`}</a>{`)`}</li>
      <li parentName="ul">{`Pagination replace Font with Typography (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7681",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7681`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/42333c917c05b971f56abdd982a4267a31562381",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`42333c9`}</a>{`)`}</li>
      <li parentName="ul">{`pass className to span when child is string or array (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7684",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7684`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ad908ef81d5ea5c02dc12afa7ecd4d7cf9f9ceb8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ad908ef`}</a>{`)`}</li>
      <li parentName="ul">{`removing outdated examples from empty state (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7695",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7695`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5e97c97cfeb1287d09cc4bb6044787a64e3b3c9a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5e97c97`}</a>{`)`}</li>
      <li parentName="ul">{`restore focus on Attach Button after closing the file explorer (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7693",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7693`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4e98df3cef1c0adc6706a930584331ca10e66212",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4e98df3`}</a>{`)`}</li>
      <li parentName="ul">{`update icon colors on search and typeahead (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7683",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7683`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/de27f65689c65389b6dc782bff6fec1e05835424",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`de27f65`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-8",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-8",
        "aria-label": "features 8 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2528]`}{` detail page read and edit states updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7520",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7520`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/76ed366242025a46e8c17f3d1e6c685d84d5b110",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`76ed366`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2623]`}{` NumberInput behavior updates (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7637",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7637`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b29b1519802e879e2b873d655fc3611e8b80eb84",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b29b151`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2634]`}{` - Introduce Keyboard Navigation For Thumbnail List (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7689",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7689`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aa506dde233855d8e6092200d63343f4a6d848d2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aa506dd`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2701]`}{` improve Tabs screenshot test coverage (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7721",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7721`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/22d7cd05cd519f7e398cfd561dfccd217420c04c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`22d7cd0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Fix FileSelect.GridSource issues (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7612",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7612`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6f35d7d37820995322858af68efc7f44bb12cbfe",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6f35d7d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2658]`}{` - Tree API Adjustment (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7674",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7674`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/be7f871e4389a01776a74f8eaec6a4b8f16fa797",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`be7f871`}</a>{`)`}</li>
      <li parentName="ul">{`introduce CurrencyInput - preconfigured NumberInput (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7659",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7659`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/027b74040ef15b60e5ff29818d3d09d3fb94161e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`027b740`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "900-2020-10-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#900-2020-10-09",
        "aria-label": "900 2020 10 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.25.0...v9.0.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`9.0.0`}</a>{` (2020-10-09)`}</h2>
    <h3 {...{
      "id": "bug-fixes-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-10",
        "aria-label": "bug fixes 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2655]`}{` restoring legacy modal behavior for FileSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7656",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7656`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/56aca59f65f0b8db154ca6bacf7f16403a08a88e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`56aca59`}</a>{`)`}</li>
      <li parentName="ul">{`bad merge (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bd14dcfae47307b2c450c95fe58d70af356bac71",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bd14dcf`}</a>{`)`}</li>
      <li parentName="ul">{`fixing v-9 modal export (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7666",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7666`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/12b77293610a50112193aa9ac253f31db25486d2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`12b7729`}</a>{`)`}</li>
      <li parentName="ul">{`Form RadioButtons and Checkboxes missing React key warning (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7652",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7652`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9f8088a88e263e78a0f160897018513b8edd6980",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9f8088a`}</a>{`)`}</li>
      <li parentName="ul">{`remove usage export (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/348e0c6282ed36ea9ccab531be8fbf6e2b7e96fa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`348e0c6`}</a>{`)`}</li>
      <li parentName="ul">{`removing this removed prop, again (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/064dcc01d00e73eead38e2a7694c375c5700b7e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`064dcc0`}</a>{`)`}</li>
      <li parentName="ul">{`undeleting Modal.State (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7600",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7600`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1741854c0c4c854c0bd6d1476a0e41d5dde50346",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1741854`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v26 (major) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6477",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6477`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2d07c50818a9baa0388d3f38b720fc63cc8b090c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2d07c50`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6460",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6460`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6459",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6459`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6458",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6458`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6461",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6461`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6449",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6449`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6462",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6462`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6450",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6450`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6457",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6457`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6434",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6434`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6464",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6464`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6463",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6463`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6402",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6402`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6470",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6470`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6469",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6469`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6467",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6467`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6466",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6466`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6465",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6465`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6483",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6483`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6482",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6482`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6479",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6479`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6481",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6481`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6474",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6474`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6472",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6472`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6476",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6476`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6473",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6473`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6480",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6480`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6486",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6486`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6485",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6485`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6484",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6484`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6487",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6487`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6471",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6471`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6468",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6468`}</a></li>
    </ul>
    <h3 {...{
      "id": "chore",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#chore",
        "aria-label": "chore permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`chore`}</h3>
    <ul>
      <li parentName="ul">{`add Dropdown.Item subcomponent (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f87912b15501e601e257a42c44a6c2a40922e990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f87912b`}</a>{`)`}</li>
      <li parentName="ul">{`add styled-components as a peerDep, update version ranges (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7437",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7437`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0b11d4822375d4d30cab16b2612dff960a0df1ee",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0b11d48`}</a>{`)`}</li>
      <li parentName="ul">{`bumping Typescript to latest version (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f82e5d9b0297beaff343ced8321ac11dda0b5208",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f82e5d9`}</a>{`)`}</li>
      <li parentName="ul">{`move formik to be a peerDep (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/89813fd5ae8e36cd0b5d82b77569859d477e5b59",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`89813fd`}</a>{`)`}</li>
      <li parentName="ul">{`remove deprecated table-cells (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4f9a8f8d9e938d6bcea8b8b01244a97eae0522ec",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4f9a8f8`}</a>{`)`}</li>
      <li parentName="ul">{`remove OverlayTrigger onVisibleChange prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bc76e3ff1a8ab53d28fed79b1f28ac9ec554d8e5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bc76e3f`}</a>{`)`}</li>
      <li parentName="ul">{`remove textareaRef prop from textarea (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a8bd351b57f2ba7f430489eb4baeb43204542a8e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a8bd351`}</a>{`)`}</li>
      <li parentName="ul">{`update date-fns to v2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6006",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6006`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a4f39140ee1ec1e4e63da9ad4c12c1039be8ec3c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a4f3914`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-9",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-9",
        "aria-label": "features 9 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2299]`}{` Form.NumberInput uses NumberInput (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7542",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7542`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/63909abea686416f3ef9487cfd9d7b8eac966c73",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`63909ab`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1932]`}{` Multiselect onSearch changes (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7505",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7505`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c1dc04d50bc91f22b337b9a4a9a3a755b2d511fc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c1dc04d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2070]`}{` remake button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7556",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7556`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d0b5482e991dcd6a2e690f972f5758427f5dabcf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d0b5482`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7593",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7593`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7601",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7601`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7585",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7585`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7603",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7603`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7604",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7604`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7607",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7607`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7608",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7608`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7609",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7609`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7610",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7610`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7579",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7579`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7521",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7521`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7576",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7576`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7552",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7552`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7617",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7617`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7618",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7618`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7619",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7619`}</a></li>
      <li parentName="ul">{`[GLUE-2375]`}{` Remove EmptyState props (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7460",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7460`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8d83809b7bd4fc8fb3d2e8b46a8c247f7530583f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8d83809`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2410]`}{` Remove deprecated i18n stuff, add useI18nContext (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7316",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7316`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d38569d0a4c7ae9a8eb22c007ae82f3d47c105e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d38569d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2412]`}{` Typeahead component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7541",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7541`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7b5290bd73cc5de9b054ce6bc0c2dd05b3c749ce",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7b5290b`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2614]`}{` deprecating and documenting isSelectable (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7636",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7636`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/657fa7137c1d6444c5ee9cf6d6f725dad00142ef",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`657fa71`}</a>{`)`}</li>
      <li parentName="ul">{`changes loading prop to processing for TableCells (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7572",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7572`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/514586228b2e696a730da74446a73ff8328b0f09",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5145862`}</a>{`)`}</li>
      <li parentName="ul">{`dropdown using imperative menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5feca476de319f9486d86f5119f0a6c16fdec45f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5feca47`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#breaking-changes",
        "aria-label": "breaking changes permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`BREAKING CHANGES`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`getLabel returns string now instead of string or ReactNode|onSearch now overrides internal onSearch,
user must filter and update their options`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`chore: update docs for onSearch example`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-docs, @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: refactor internal options to useMemo`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: add note banner to onSearch docs`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`chore: actually narrow getLabel`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: add migration guide for MultiSelect`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`chore: update migration guide example to have proper dom`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`docs: multiselect advanced example v9 changes. update prop docs`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`removing deprecated i18n polyfill default export`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`test: fix tests`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`chore: remove old docs-v2 file`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`chore: useDeprecation`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`docs: add migration guide`}</li>
    </ul>
    <p>{`affects: @procore/core-docs, @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`docs: fix docs for dateselect and texteditor`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`docs: fix some typos`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`chore: fix migration guide content order`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`chore: use RTL and update tests for i18n`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: add tsconfig for prod builds`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: update tsconfigs to account for all environments`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: fix type error in test`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`remove variant, add compact prop, add subcomponents for presets`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`feat: update stories`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`feat: refactor emptystate, add subcomponents`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <p>{`Rewrite EmptyState to use context for compact mode
Add subcomponents for NoItems, NoResults, and
RRecycleBin`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`removes the one-off "src" values from EmptyState.Image in favor of subcomponents`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`chore: update grid`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: remove old props from docs`}</li>
    </ul>
    <p>{`affects: @procore/core-docs, @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: address cr`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: fix emptystate in fileexplorer`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: update EmptyState docs`}</li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">{`chore: add migration guide`}</li>
    </ul>
    <p>{`affects: @procore/core-docs, @procore/core-react`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`TableCells prop change from loading -> processing`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`docs: adding in a short note about the prop change to guide`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-docs`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`fix: updating specs`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`fix: removing unusable docs, for real`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`adding styled-components as a peerDependency`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`formik is now a peerDep`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Dropdown should now use Dropdown.Item instead of Menu.Item`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Core-scripts Type-checking Breaking Changes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Removing deprecated table-cells components and css`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Removal of onVisibleChange prop, use visibility lifecycle hooks instead (beforeShow, beforeHide,
afterShow, afterHide)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`We no longer export CalendarHelpers. use date-fns directly instead`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Removing textareaRef prop, use ref instead`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "8250-2020-10-01",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8250-2020-10-01",
        "aria-label": "8250 2020 10 01 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.24.0...v8.25.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.25.0`}</a>{` (2020-10-01)`}</h2>
    <h3 {...{
      "id": "bug-fixes-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-11",
        "aria-label": "bug fixes 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2600]`}{` - FileToken. Update Label Truncation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7615",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7615`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bd663ea5801db6174d4f1797a1e0d6f177ca9b8b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bd663ea`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2619]`}{` Select. Restore circular navigation and onScrollBottom functionality. (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7613",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7613`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bf66e7dddb6464a99bdf0062bdd426af2847b19f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bf66e7d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2629]`}{` NumberInput imprecise formatting in Safari (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7625",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7625`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dd9d4cf9df652d37f34ed5243ab98f7fdd56ae30",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dd9d4cf`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-10",
        "aria-label": "features 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2271]`}{` Pill Select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7540",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7540`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5ac9b1413b946cb3782e6632e69c47f9f3a9a2d4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5ac9b14`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2615]`}{` fixing banner typography (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7584",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7584`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f4d63c7497f2c8babe7b558d5c2529c8ab7fc12c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f4d63c7`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2620]`}{` - Update ThumbnailGrid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7606",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7606`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7dd95e6fc7d97266a45895c0234031edb2f4d4f9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7dd95e6`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8240-2020-09-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8240-2020-09-28",
        "aria-label": "8240 2020 09 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.23.1...v8.24.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.24.0`}</a>{` (2020-09-28)`}</h2>
    <h3 {...{
      "id": "bug-fixes-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-12",
        "aria-label": "bug fixes 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Form Inline Error Style and Validation Tweak (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7604",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7604`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f08b3e00cd45baf22e9ff183b213eb6c84d2034a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f08b3e0`}</a>{`)`}</li>
      <li parentName="ul">{`Form.Field.Create Props Type Correction (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7592",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7592`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c567a74ce9d3f67dd5e058d227d1dfe6d9fc0cae",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c567a74`}</a>{`)`}</li>
      <li parentName="ul">{`removing ActionButton + ActionDropdown (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7585",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7585`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fce98a3a0a4c2c69d30d1f8dc466b93bf0fd3e22",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fce98a3`}</a>{`)`}</li>
      <li parentName="ul">{`updated resize observer hook, and its usage (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7555",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7555`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bbaa39e82fde5ebd29e6bb0c69a1979c540a4d9b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bbaa39e`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-11",
        "aria-label": "features 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2023][Glue 1964]`}{` Form Inline Errors and Banner (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7501",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7501`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1e3c5ed81e882d1f5200897b68c162f7dc4df81f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1e3c5ed`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7420",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7420`}</a></li>
      <li parentName="ul">{`[GLUE-2134]`}{` Tiered Select Non-Selectable Tiers UX Update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7521",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7521`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1f8094558315d8bb8d39cbc44c61fce8d650262a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1f80945`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2163]`}{` Currency Input (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7347",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7347`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2b3b9e7137aa3c7dda90eec7e6ef0ad0e54c1215",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2b3b9e7`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2532]`}{` - Lazy-loading API for ThumbnailGrid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7395",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7395`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bfcf4e6422a871819300e368c33f4c5540ebd34f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bfcf4e6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2578]`}{` UX changes to file attacher & file select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7579",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7579`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/49a10311649911e99cd13a334f7675eb39bc6557",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`49a1031`}</a>{`)`}</li>
      <li parentName="ul">{`introduce FileSelect component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7137",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7137`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7325ab403c61633062daecda024d8b76ea0e524a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7325ab4`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-2",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-2",
        "aria-label": "reverts 2 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`Revert "chore: `}{`[GLUE-2595]`}{` - File Select optimization (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7552",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7552`}</a>{`)" (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7617",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7617`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4a8e288969a63e8c933a707a620bc358deaf2574",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4a8e288`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8231-2020-09-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8231-2020-09-14",
        "aria-label": "8231 2020 09 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.23.0...v8.23.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.23.1`}</a>{` (2020-09-14)`}</h2>
    <h3 {...{
      "id": "bug-fixes-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-13",
        "aria-label": "bug fixes 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`(docs hidden break) number input decimalScale defaults to true (allow decimal numbers) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7543",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7543`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b9762c04133731495c6a3ea225b19bc75d778100",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b9762c0`}</a>{`)`}</li>
      <li parentName="ul">{`export Font props interface (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dbb0adfbbe41e0add2505cb00f829af054b878de",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dbb0adf`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8230-2020-09-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8230-2020-09-10",
        "aria-label": "8230 2020 09 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.22.0...v8.23.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.23.0`}</a>{` (2020-09-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-14",
        "aria-label": "bug fixes 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2511]`}{` WXPDetailPage - Multiple Content Cards (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7504",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7504`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b373dcc1586ecdfb4edb17ecd006beef74ecc76f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b373dcc`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2596]`}{` Dropzone height in FileExplorer.LocalFiles flickers during rendering. Outer div of FileExplorer.ThumbnailGrid is in the tab order on FF. (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7528",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7528`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6be099995fc7cfc0a0f4b7e774973da881976391",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6be0999`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-12",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-12",
        "aria-label": "features 12 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1968]`}{` Number Input (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7190",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7190`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bba9e64bb8f98863f4e23ed1e76d3e44ea5e8a38",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bba9e64`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7458",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7458`}</a></li>
      <li parentName="ul">{`[GLUE-2494]`}{` Detail Page Section (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7427",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7427`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c091483bc6d881e78a00495df1e4f276c058f46c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c091483`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2534]`}{` Virtualization and Groups API for ThumbnailGrid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7400",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7400`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5572eb3eda826b248c15c5be0373f66691007c61",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5572eb3`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8220-2020-08-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8220-2020-08-28",
        "aria-label": "8220 2020 08 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.21.0...v8.22.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.22.0`}</a>{` (2020-08-28)`}</h2>
    <h3 {...{
      "id": "bug-fixes-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-15",
        "aria-label": "bug fixes 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Form Checkboxes and Select TS - docs: Form DateSelect Date String (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7445",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7445`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7d5481260e996d437c2927ccfa686d0fefaf45f2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7d54812`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-13",
        "aria-label": "features 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2285]`}{` Text Editor Error (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7382",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7382`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dcd838b6516cfc16000b91033fcf0ac22d915b77",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dcd838b`}</a>{`)`}</li>
      <li parentName="ul">{`[glue-1972]`}{` Checkbox Radio Button Error (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7390",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7390`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cb0495a07d289921b634e2e4a01a46fef763cd53",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cb0495a`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2418]`}{` Add FileTree to the FileExplorer (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7243",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7243`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/378be88926d871e253cfa885b595e3ed07405377",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`378be88`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2457]`}{` Tabs using new Menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7291",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7291`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/047c178ce10adcb915e41e83b72b49205753ee19",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`047c178`}</a>{`)`}</li>
      <li parentName="ul">{`GLUE-2509 New Typography Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7361",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7361`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/749aefb0609e112042293f9d0872a4fc54f4f3aa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`749aefb`}</a>{`)`}</li>
      <li parentName="ul">{`toolbar for FileExplorer.Grid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7396",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7396`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ea0e3d8d366cae311cee1ca64b81f558e27c8ebc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ea0e3d8`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8210-2020-08-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8210-2020-08-13",
        "aria-label": "8210 2020 08 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.20.0...v8.21.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.21.0`}</a>{` (2020-08-13)`}</h2>
    <h3 {...{
      "id": "features-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-14",
        "aria-label": "features 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2350]`}{` Add a qa prop to multiselect for configuring internal elements (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7383",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7383`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f1f638684ea08ba5071c3ea97d7cc2c6ad82e7cd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f1f6386`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2388]`}{` MultiSelect using imperative menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7260",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7260`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9a6aca061db03a2b3a2e78e139c56e4c13e3cf94",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9a6aca0`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2455]`}{` Pagination with new Menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7294",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7294`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c555387692d7b0785790c1484b201fd0759fd60a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c555387`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2527]`}{` New Pill component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7384",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7384`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/97331997b15b842ed483a1c0822e5fff85d715fa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9733199`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2556]`}{` Update EmptyState in FileExplorer to use variant="compact" (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7421",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7421`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4def5b27def60422f123ad9eafc3dc0848e2cd29",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4def5b2`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6929",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6929`}</a></li>
    </ul>
    <h2 {...{
      "id": "8200-2020-07-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8200-2020-07-31",
        "aria-label": "8200 2020 07 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.19.0...v8.20.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.20.0`}</a>{` (2020-07-31)`}</h2>
    <h3 {...{
      "id": "bug-fixes-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-16",
        "aria-label": "bug fixes 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[glue-2454]`}{` Banner text alignment when no title (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7325",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7325`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e6fa4bdc8e6e3259a0f30a531656150cb02ad548",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e6fa4bd`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2524]`}{` fix ZIndex for Portal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7369",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7369`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a6b2c261da6c9060c38258f2b3410b3d624f43f1",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a6b2c26`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2525]`}{` Increase modal specificity (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7371",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7371`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ef7eaf31438bb68edf819fdf1fd242f70138b1d4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ef7eaf3`}</a>{`)`}</li>
      <li parentName="ul">{`highlight first item when navigation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7370",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7370`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8eaa60b8e55740ca01875291d643b327c943857e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8eaa60b`}</a>{`)`}</li>
      <li parentName="ul">{`use the proper default i18n scope for menu search (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7401",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7401`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e0bccd9c98fe28ae820c98fba4b84c605214b32b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e0bccd9`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-15",
        "aria-label": "features 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2384]`}{` Select using MenuImperative (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7253",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7253`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d31432741a35551857547642ec3673e1c23a7614",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d314327`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2492]`}{` Detail Page action buttons and v2 docs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7352",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7352`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ac28e6db9ecf78f2068b18efa98203c417d504b0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ac28e6d`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8190-2020-07-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8190-2020-07-21",
        "aria-label": "8190 2020 07 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.18.3...v8.19.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.19.0`}</a>{` (2020-07-21)`}</h2>
    <h3 {...{
      "id": "bug-fixes-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-17",
        "aria-label": "bug fixes 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2493]`}{` Form TypeScript Improvement (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7322",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7322`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5bb9481443e9f9480be68a053566aa3ba2c3926",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5bb948`}</a>{`)`}</li>
      <li parentName="ul">{`allow custom components with no html (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3cf323468ccabcb9817713a5641b34b74c9e517",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3cf323`}</a>{`)`}</li>
      <li parentName="ul">{`Box type of flex should be string | number (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7321",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7321`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c179a6f4177187f738794c76d772adb9f0438694",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c179a6f`}</a>{`)`}</li>
      <li parentName="ul">{`export type to allow custom components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c89c2c50e11dce95e8fc0b38293583180172c7b0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c89c2c5`}</a>{`)`}</li>
      <li parentName="ul">{`indicate all keys required when using object api (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2a7ef727cdb1ae78b6219b96ef2ce573cbd886dd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2a7ef72`}</a>{`)`}</li>
      <li parentName="ul">{`third tier children api (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6818a21bfb56908389ae0b7b8237e0554b8b60a3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6818a21`}</a>{`)`}</li>
      <li parentName="ul">{`update FileExplorer.LocalFiles uploading state when it is unmounted (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7304",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7304`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3c8f721cacdadccfe2356e0b055ee5f759893a9e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3c8f721`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-16",
        "aria-label": "features 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2284][Glue 2286]`}{` Add RadioButtons and Checkboxes to Form (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7221",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7221`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/91990ef953981c79896982518f2dddc4e9e953e0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`91990ef`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5351",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5351`}</a></li>
      <li parentName="ul">{`[GLUE-2355]`}{` Form Select Groups and Custom Renders (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7193",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7193`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8a5c3c14695d77b0d26053423882ac740eaff45a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8a5c3c1`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8183-2020-07-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8183-2020-07-16",
        "aria-label": "8183 2020 07 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.18.2...v8.18.3",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.18.3`}</a>{` (2020-07-16)`}</h2>
    <h3 {...{
      "id": "bug-fixes-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-18",
        "aria-label": "bug fixes 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2124]`}{` top left portal interrupts pointer events (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7267",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7267`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d272fe650d46251dbe99f4ccb20f4b90ecca473e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d272fe6`}</a>{`)`}</li>
      <li parentName="ul">{`fixes pluralization in file tree and dropzone (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7251",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7251`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2fe8a67545ee08c49f29f6a7c17af4f3e273497f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2fe8a67`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7205",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7205`}</a></li>
    </ul>
    <h2 {...{
      "id": "8182-2020-07-14",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8182-2020-07-14",
        "aria-label": "8182 2020 07 14 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.18.1...v8.18.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.18.2`}</a>{` (2020-07-14)`}</h2>
    <h3 {...{
      "id": "bug-fixes-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-19",
        "aria-label": "bug fixes 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`Form missing children from read view (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7305",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7305`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1296dc005f24b118abfe161a7e005590a30dc41f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1296dc0`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8180-2020-07-13",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8180-2020-07-13",
        "aria-label": "8180 2020 07 13 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.17.0...v8.18.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.18.0`}</a>{` (2020-07-13)`}</h2>
    <h3 {...{
      "id": "bug-fixes-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-20",
        "aria-label": "bug fixes 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2430]`}{` Banner overlaps to dropzone after second uploading files with unsupported file types (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7089",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7089`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1e2ede6f39592071449668d5c25cbe4ad159cbd0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1e2ede6`}</a>{`)`}</li>
      <li parentName="ul">{`fixing up types and declarations (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7225",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7225`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b241cbb48c1b3cce9c2dcc22ae98a019fc57e46a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b241cbb`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-17",
        "aria-label": "features 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1928]`}{` Introduce FileTree component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6389",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6389`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c210f332cbca14af611289f755ad242a1094c388",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c210f33`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2292]`}{` Prevent form submission with enter key with input focus (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6866",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6866`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5183d8cf5f7c3a14f9e366b311547992aa22ee27",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5183d8c`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2294]`}{` Form Text Area Display Blank Space (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7032",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7032`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c318c9bbadbea3ad9c9e5bedbf7b661a924a0813",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c318c9b`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2385]`}{` Dropdown using new menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7079",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7079`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ff27ef8ebc7cb8cb0955e14586f6a45090ef4d63",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ff27ef8`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2387]`}{` tiered select imperative menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7125",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7125`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/16209ebb6fe5dcd14cc8af482448a395129b1730",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`16209eb`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-3",
        "aria-label": "reverts 3 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`"feat: `}{`[GLUE-2385]`}{` Dropdown using new menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7079",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7079`}</a>{`)" (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7245",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7245`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f42f687643938626d52434fcfaa661139bcb13ca",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f42f687`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8170-2020-06-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8170-2020-06-26",
        "aria-label": "8170 2020 06 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.16.1...v8.17.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.17.0`}</a>{` (2020-06-26)`}</h2>
    <h3 {...{
      "id": "bug-fixes-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-21",
        "aria-label": "bug fixes 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2424]`}{` Use correct error icon on Banner (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7059",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7059`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5071f3ee2e6ccf2b7d00334a3bc118f69039932d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5071f3e`}</a>{`)`}</li>
      <li parentName="ul">{`remove extra setDisplayed causing old date to appear on cal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6978",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6978`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3ef5f0179be5d24d68681cf1a7fcdcc3d60bb928",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3ef5f01`}</a>{`)`}</li>
      <li parentName="ul">{`remove onSelect from DateSelect props (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5925",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5925`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1071a47097b9cbd339dd63734de23ec255c153cf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1071a47`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @tinymce/tinymce-react to v3.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5920`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d9ecc516a5083637be6e9157faa29e4c257730e4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d9ecc51`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.8.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5904",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5904`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a5326d63c70884e9d28729face9267c1bcd19cff",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a5326d6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update react monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5947",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5947`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ad74eb130a553c4c5b99fef9ddeb15121506b5aa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ad74eb1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.21.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5926",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5926`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/83de6f811de00a6315dd4ddf041bed343623ac80",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`83de6f8`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-18",
        "aria-label": "features 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[Glue 2352]`}{` Form 12 Column Grid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/7012",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#7012`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/94972241c5d48b9e99035ed91ccdc8cc4ce21f0f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9497224`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1770]`}{` Imperative Menu (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6992",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6992`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/41049181fb5f801525f93e1eec02f0dfedcbd83e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4104918`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` allow Link to be used without href prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5927",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5927`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e598e06061d1b219544210d9f213cafdc22262cc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e598e06`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` story for input field (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5929",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5929`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7e11d25d7cbeed947c2ec3ed93a995922ea26932",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7e11d25`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8161-2020-06-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8161-2020-06-25",
        "aria-label": "8161 2020 06 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.16.0...v8.16.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.16.1`}</a>{` (2020-06-25)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "8160-2020-06-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8160-2020-06-16",
        "aria-label": "8160 2020 06 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.15.0...v8.16.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.16.0`}</a>{` (2020-06-16)`}</h2>
    <h3 {...{
      "id": "bug-fixes-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-22",
        "aria-label": "bug fixes 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`dark mode corrections on tabs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6937",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6937`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/17cc1e5f1c297deeb7859d64fcf3a2399fffbf3d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`17cc1e5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` fix tabindex (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a20de2f0b68e3390d3b76e38b4db100aaa9e9de3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a20de2f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react, core-css:`}</strong>{` address review comments (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7ff560b36c53ea23e74f3c7d621c0dba0c39a727",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7ff560b`}</a>{`)`}</li>
      <li parentName="ul">{`add index-based key to Banner Actions (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0fdfc3603717691b5c0a1acff2c4eb5f09b59964",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0fdfc36`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-19",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-19",
        "aria-label": "features 19 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react, core-css:`}</strong>{` implement FileList component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/245f728f7e35ad413cb31eb24e7a7c55dfc20370",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`245f728`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react,core-docs,core-css:`}</strong>{` introduce FileAttacher component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/66ee19db4f45a849760ac5bd6436d1b1bc321985",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`66ee19d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2348]`}{` Adding new cases in StoryBook for ProgressBar component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6841",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6841`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/33b56a290c20b4774961b9193442896551f5309a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`33b56a2`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8150-2020-06-04",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8150-2020-06-04",
        "aria-label": "8150 2020 06 04 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.14.1...v8.15.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.15.0`}</a>{` (2020-06-04)`}</h2>
    <h3 {...{
      "id": "bug-fixes-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-23",
        "aria-label": "bug fixes 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` fix storybook build failure (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6862",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6862`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/41ebc350c7699616e533096a80b88cfb07d52e11",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`41ebc35`}</a>{`)`}</li>
      <li parentName="ul">{`add name to the memoization dependency list (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f38ae2616079304fa0a18aa6ef75725d2c9c8464",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f38ae26`}</a>{`)`}</li>
      <li parentName="ul">{`moving images to EmptyState component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6757",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6757`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ff595c1a59b7946e229f8fc1733030bd66915b20",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ff595c1`}</a>{`)`}</li>
      <li parentName="ul">{`remove labelClassName API (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6771",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6771`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/43ae822a6f2f78efb78d9cefa27d15b3a310be6d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`43ae822`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-css:`}</strong>{` fix white overlay being shown on a focused thumbnail (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6714",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6714`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6e08caaa04716988719e7c86a84ccee58529077b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6e08caa`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2283]`}{` Form.Form Update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6723",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6723`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d9dbfa1873b81fb14d709ca1050aea55615c5ce5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d9dbfa1`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4164",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4164`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com//github.com/procore/core/projects/7/issues/card-38243341",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`/github.com/procore/core/projects/7#card-38243341`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4990`}</a></li>
    </ul>
    <h3 {...{
      "id": "features-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-20",
        "aria-label": "features 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2184][glue-2192]`}{` Paragraph and Unordered List (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5431",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5431`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8a3d6401f05c473c53506411c5135593d41be869",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8a3d640`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "performance-improvements",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#performance-improvements",
        "aria-label": "performance improvements permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Performance Improvements`}</h3>
    <ul>
      <li parentName="ul">{`memoize useField requiredness check (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3971ba63c1ba7907a6d93af263761f39a0b02833",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3971ba6`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8141-2020-05-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8141-2020-05-21",
        "aria-label": "8141 2020 05 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.14.0...v8.14.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.14.1`}</a>{` (2020-05-21)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "8140-2020-05-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8140-2020-05-21",
        "aria-label": "8140 2020 05 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.13.0...v8.14.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.14.0`}</a>{` (2020-05-21)`}</h2>
    <h3 {...{
      "id": "features-21",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-21",
        "aria-label": "features 21 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`new variant prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8ce4a01578379950dd633c727d6884159613ac18",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8ce4a01`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8130-2020-05-20",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8130-2020-05-20",
        "aria-label": "8130 2020 05 20 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.12.0...v8.13.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.13.0`}</a>{` (2020-05-20)`}</h2>
    <h3 {...{
      "id": "bug-fixes-24",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-24",
        "aria-label": "bug fixes 24 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Fix Storybook box-sizing CSS (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9b674f922cc7e82833cf29150628d630e74b55db",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9b674f9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Thumbnail caption customization fix (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6608",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6608`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/941f7451e3b9a634a14205d166682af97efc7e17",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`941f745`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/jest to v25.2.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6578",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6578`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/183ac23cd970266032e4aa1f87ff56df9158af22",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`183ac23`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/jest to v25.2.3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6641",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6641`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3ae6d7a40f1dcf56ee4bdc191b78dbeb2b83433f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3ae6d7a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.39 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6570",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6570`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3711ed0986a900fb4d2588096a0108c3fd42587",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3711ed`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-plugin-react-hooks to v4.0.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6556",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6556`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2c2a027ffb72cd333b1471346ada60521c8b41e2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2c2a027`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-plugin-react-hooks to v4.0.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6576",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6576`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/07246af72520d443d09c2d843dece5a0192dccd4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`07246af`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.32.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6549",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6549`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/10bd32b642eb377740d6554a29bd3b524a6636c4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`10bd32b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.33.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6566",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6566`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c07e068abca2975d01dd24c4f4f6a32349d5b947",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c07e068`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.34.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6636",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6636`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cb4162cf3d324c21b8b18616435b219d516b82dd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cb4162c`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-22",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-22",
        "aria-label": "features 22 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1929]`}{` Token List component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6222",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6222`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cc9253048fd518ce89e163417cdaf71da5beae24",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cc92530`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` Add "clickable" Thumbnail API to allow preventing hover UI effects (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6605",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6605`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a1507b5a344ce0eab250df1b6954d11809b3c22a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a1507b5`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2220]`}{` dropzone error banner resets dropError on dismiss (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6519",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6519`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d40bc13f3b568a9618cd2773e417121b3a2c5a3b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d40bc13`}</a>{`)`}</li>
      <li parentName="ul">{`exposing contact-item publicly, size just medium (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f4ecac51fae3534cb86fd45d81de37e2be9a3279",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f4ecac5`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8120-2020-05-08",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8120-2020-05-08",
        "aria-label": "8120 2020 05 08 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.11.0...v8.12.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.12.0`}</a>{` (2020-05-08)`}</h2>
    <h3 {...{
      "id": "bug-fixes-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-25",
        "aria-label": "bug fixes 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`behavior correction:`}</strong>{` `}{`[GLUE-2191]`}{` Prevent final animation on re-mount and re-visible FileToken component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6503",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6503`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/41f4668d508edc7b47334462df1a9579bf5fcccc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`41f4668`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`behavior correction:`}</strong>{` Prevent final animation of ProgressBar component on mounting (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6475",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6475`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f48a1c559b9c95eb13602cf2124d81e00797188c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f48a1c5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` `}{`[GLUE-2195]`}{` Form Checkbox Undefined Initial Value (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6497",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6497`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7e1dae7735aba87bdc3192edba4b0f04c4b92016",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7e1dae7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @tinymce/tinymce-react to v3.6.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6514",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6514`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fcd974323ed2661b54e912d6278314be8f622594",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fcd9743`}</a>{`)`}</li>
      <li parentName="ul">{`hide overlay when trigger is "none" (OverlayTrigger) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6434",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6434`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a363d5d7ceebe8ccd037bbe02238c4533a53f4de",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a363d5d`}</a>{`)`}</li>
      <li parentName="ul">{`same domain urls were being changed to relative hrefs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6449",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6449`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/57e0e5222d31a1c8a33a3ab8add964872033388c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`57e0e52`}</a>{`)`}</li>
      <li parentName="ul">{`satisfying typescript/linter warnings (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6433",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6433`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dd2f1ee08b96c3b6072af24a73cdb53375a14b78",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dd2f1ee`}</a>{`)`}</li>
      <li parentName="ul">{`Thumbnail issues (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6425",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6425`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/caf705da5e6dd950c9a03ae1aef659786862a995",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`caf705d`}</a>{`)`}</li>
      <li parentName="ul">{`undefined checkbox value keeps as boolean (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ae64131454ecbb9546b1eab4a640db9b9f8e4622",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ae64131`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`behavior correction:`}</strong>{` Preventing of extra animation after ProgressBar component re-rendering (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6379",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6379`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9779311d9e506128e77e5a437013a5fac7e23465",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9779311`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @tinymce/tinymce-react to v3.5.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6453",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6453`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b2d4b1129aec7c9a78f977efd4b1cb06207f641d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b2d4b11`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.38 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6491",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6491`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d52a3ccdf5b7b2f3bbaf49a70830eda8fedb3923",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d52a3cc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-plugin-react-hooks to v4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6466",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6466`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d5ea25495cac58364f15bb8865212c04eeb5d2b3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d5ea254`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency node-sass to v4.14.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6482",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6482`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/77c2c4da61e4fc089e0d80810a0ce42971c7a3e0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`77c2c4d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6440",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6440`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/204b2e491f154e71fa16f17e975624d1b121a7b6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`204b2e4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.5.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6443",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6443`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e919c4752de0c7e82346a1408c0e9278ee188c28",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e919c47`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.30.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6424",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6424`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a66670c4f43aae7f8bade9a08176d3613b11a76d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a66670c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.31.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6476",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6476`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8c1b50fba37c46211efcf4d145f870a8d711d51f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8c1b50f`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8110-2020-04-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8110-2020-04-27",
        "aria-label": "8110 2020 04 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.10.0...v8.11.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.11.0`}</a>{` (2020-04-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-26",
        "aria-label": "bug fixes 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.36 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6362",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6362`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c24a2691ec702c7977944654b72c52edb807cd4a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c24a269`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.37 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6387",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6387`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6c0c71458f17b5d130a1e69cb4ab4e8e9d1e5059",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6c0c714`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.11.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6385",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6385`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/74ef8e8ef2b9f93c84ec9ff76557c15c6de20855",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`74ef8e8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency node-sass to v4.14.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6396",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6396`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4bbc6904fea9da1f8cb472b6854d32284412e49c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4bbc690`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency react-dropzone to v10.2.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6359",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6359`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/64d953d0f4d426b520b704a2b673d4eedc59e0e6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`64d953d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.4.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6367",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6367`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dfcdc0b3890fff37889cf5f63efa0628d0243130",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dfcdc0b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.29.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6370",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6370`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/52af1e65474c94870a6c308d0633128f0911c6b5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`52af1e6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2136][glue-1963]`}{` Form Style Updates and More Docs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6292",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6292`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/be0a75cd1ed1b11a65ba874d5aca31ce182a96bf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`be0a75c`}</a>{`)`}</li>
      <li parentName="ul">{`make formik a true dep (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6345",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6345`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3a01c5ac2ce7f8f4626e9e4f08491f2ad11ca9e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3a01c5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.28.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6324",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6324`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2953da0c4b54f18f979f64a14f10defc64721ac2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2953da0`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-23",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-23",
        "aria-label": "features 23 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1925]`}{` Introduce Dropzone component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5796",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5796`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fac351643a48c9fde558ebfb4d9405a4756eaa70",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fac3516`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5920`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5922",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5922`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5919",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5919`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5918",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5918`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5917",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5917`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5916",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5916`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5904",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5904`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5926",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5926`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5931",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5931`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5928",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5928`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5933",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5933`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5932",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5932`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5925",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5925`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5924",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5924`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5921",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5921`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5940",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5940`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5935",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5935`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5941",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5941`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5936",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5936`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5939",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5939`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5938",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5938`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5934",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5934`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5937",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5937`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5927",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5927`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5929",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5929`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5942",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5942`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5943",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5943`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5947",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5947`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5945",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5945`}</a></li>
      <li parentName="ul">{`[GLUE-1946]`}{` - Introduce FileToken component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6100",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6100`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bfb94af860a45bddf328cead7e5ff9218f03f337",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bfb94af`}</a>{`)`}</li>
      <li parentName="ul">{`[Glue-1975][glue-1967]`}{` Form Tooltip, Tiered Select, Group Select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6341",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6341`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4083672a4fc955cf8720422c1d1ad7e3f0bca5b0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4083672`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2074]`}{` Updating to use latest tinymce (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6220",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6220`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f87c45be791a315ff95e5f02b32ed1bd858a451d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f87c45b`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "8100-2020-04-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#8100-2020-04-10",
        "aria-label": "8100 2020 04 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.9.1...v8.10.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.10.0`}</a>{` (2020-04-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-27",
        "aria-label": "bug fixes 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`actiondropdown story (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6312",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6312`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b0ba949d9e6db9b99c16a684cbe1fbaa0d7700c8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b0ba949`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.35 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6290",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6290`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f3a211b42b8f7132e397ebfa0790c0389d29709d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f3a211b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.3.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6280",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6280`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0ddc6295383173681154d9c7e26a8e58efb86605",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0ddc629`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2066]`}{` add correct size to confirm modal icon (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6256",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6256`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6d9d76e7797b4519853505fdc88eb853c2aa733c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6d9d76e`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2106]`}{` dynamic OverlayTrigger "trigger" prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6193",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6193`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3b23bb1f3266b249b37514f1ba052a0105a3581e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3b23bb1`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5333",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5333`}</a></li>
      <li parentName="ul">{`no longer using line height (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6261",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6261`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3db9016dcc5987d5159aa664be4312b583997f48",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3db9016`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/jest to v25.1.5 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6230",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6230`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ec93d824b41c746bb1b0f85aa0ecd80d27fada93",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ec93d82`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/jest to v25.2.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6244",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6244`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e60e8b3eeddd6186c5b233cae82f1313610ba3d6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e60e8b3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.32 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6160",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6160`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2425963c4839358e2637bf0b3fbef2fd923c63e4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2425963`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.33 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6184",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6184`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/172b4e5813f8fefc497fac4fd928d8de1a26ee38",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`172b4e5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.34 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6187",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6187`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7f06ed680e640c8133e8edbaaf54f9ed1b495359",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7f06ed6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-plugin-react-hooks to v3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6155",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6155`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/eb384fa88f222219917b4bc709f9cfa330e87182",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`eb384fa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.2.3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6156",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6156`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7579f2668ccf467bbdb8dfb2d1f34d835d632bda",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7579f26`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.2.4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6172",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6172`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8c4572774d333e7bc6a7d499d949bb93f959bde7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8c45727`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.2.6 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6224",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6224`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/78a1e064139a45ddb8d0230da364e323fa658292",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`78a1e06`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.26.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6177",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6177`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7bfe953fd5a89187d1856a424b70a9a7abd007ed",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7bfe953`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.27.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6254",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6254`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/defbfde80042f9b246f9e84ee25a97a1414b6801",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`defbfde`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-24",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-24",
        "aria-label": "features 24 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-2019]`}{` - Banner Component Update (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6080",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6080`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/56b520da1755d42e3c3cedafad925928707d0931",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`56b520d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2024]`}{` Core React Form (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6055",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6055`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f4e353dac7bca99741576ff8677729414e6920fb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f4e353d`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2095]`}{` Update means of user interaction for ActionDropdown (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6158",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6158`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1bec1ddafe5b57c18d383050ce127d0fe09cf2da",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1bec1dd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react,core-docs,core-css:`}</strong>{` introduce Thumbnail components (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5807",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5807`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6232",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6232`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7a5227f06d02f0bf29f46c5d6f9e2c48f203382b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7a5227f`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "890-2020-03-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#890-2020-03-26",
        "aria-label": "890 2020 03 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.8.1...v8.9.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.9.0`}</a>{` (2020-03-26)`}</h2>
    <h3 {...{
      "id": "bug-fixes-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-28",
        "aria-label": "bug fixes 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/jest to v25.1.4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6028",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6028`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/df7dbeb1360314ab030bc51712664fbd220f13be",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`df7dbeb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.30 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6066",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6066`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9f828f4d61ef084548156ee56c61468e9063d781",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9f828f4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.31 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6136",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6136`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/196be0228f837b87e579e7453efff82294afe15c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`196be02`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.10.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6114",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6114`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e908055b64393b6ac9c5e605e635b9dc4649448e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e908055`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6145",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6145`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/40db0ccdf43ab9aec9d87335704ba1331e3394ca",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`40db0cc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25.2.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6142",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6142`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4558d28f4bdb6bb1b2ad3eeaa7fbc457418ce4c3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4558d28`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update react monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6102",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6102`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/32f3f7e5b5c39fecbe36ac4635e6de08cd1c180c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`32f3f7e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.23.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6033",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6033`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2cec80b7ec6c620ce5d8b3d5527ced386ea816db",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2cec80b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.24.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6079",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6079`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/067b438e85a60afeccf58473b18d1649188769d2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`067b438`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.25.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6123",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6123`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6da7cdb4153fe5d29a7d002f270d33f007c57c2c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6da7cdb`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-25",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-25",
        "aria-label": "features 25 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1927]`}{` ProgressBar component implementation (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5886",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5886`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e595fd5b50f45e7ff4ebe4973e3a1ab5f3de7446",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e595fd5`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-2048]`}{` - Action Dropdown Component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6077",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6077`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2ad83b558d07e287bf08f5deae305919bacee9e3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2ad83b5`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "881-2020-03-10",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#881-2020-03-10",
        "aria-label": "881 2020 03 10 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.8.0...v8.8.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.8.1`}</a>{` (2020-03-10)`}</h2>
    <h3 {...{
      "id": "bug-fixes-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-29",
        "aria-label": "bug fixes 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`update core-react readme (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fe82901b65ccd2dbbada7382acb7a25e47f6386a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fe82901`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "880-2020-03-05",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#880-2020-03-05",
        "aria-label": "880 2020 03 05 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.7.0...v8.8.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.8.0`}</a>{` (2020-03-05)`}</h2>
    <h3 {...{
      "id": "bug-fixes-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-30",
        "aria-label": "bug fixes 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`add babel-loader as a dep to fix storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5990",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5990`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9b98acce66a2d87b8677d0546b92585c0ebd4e7f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9b98acc`}</a>{`)`}</li>
      <li parentName="ul">{`hide multiselect when arrow is clicked (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5789",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5789`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/98c9cef763973eec225188f94613a1ff16cd461a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`98c9cef`}</a>{`)`}</li>
      <li parentName="ul">{`if passed i18n object, override fallbacks/default locale (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/6009",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#6009`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/312a5d0ca545c40e5836b05a6a51dcc98adb5978",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`312a5d0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.29 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5965",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5965`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2f56d4a38957661caf0f757c2f74a207aaf42e96",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2f56d4a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.8.3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5968",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5968`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/26c67ea963375e5a55521bbc35f7ebde231e16f6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`26c67ea`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.22.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5975",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5975`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7b92a2385ddd22f9643e6b1e21cb94b3089641fa",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7b92a23`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-26",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-26",
        "aria-label": "features 26 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1911]`}{` introduce GroupSelect component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5633",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5633`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cf6d7aa4fe82754d4c3e0889dc57a2452747328f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cf6d7aa`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1986]`}{` introduce Action component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5864",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5864`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/42cd52c2eb5a669752ccba32c5bef45ef7127f9b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`42cd52c`}</a>{`)`}</li>
      <li parentName="ul">{`Component Variables 1: Button, Dropdowns, Tab Links (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5946",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5946`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/025a45404d118d95380460e4fe86f00f1244331b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`025a454`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react,core-docs,core-css:`}</strong>{` `}{`[GLUE-1922]`}{` introduce OverflowObserver component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5717",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5717`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ec846b35a4ce112f45915a0bc314eb90195fe583",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ec846b3`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "870-2020-02-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#870-2020-02-28",
        "aria-label": "870 2020 02 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.6.0...v8.7.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.7.0`}</a>{` (2020-02-28)`}</h2>
    <h3 {...{
      "id": "bug-fixes-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-31",
        "aria-label": "bug fixes 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update react monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5947",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5947`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5cad9e19be5488a912710fdeff0efc5a62fd86e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5cad9e`}</a>{`)`}</li>
      <li parentName="ul">{`remove onSelect from DateSelect props (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5925",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5925`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bf34330eea53bdd2aedf5dac86e7962854afd4bf",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bf34330`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @tinymce/tinymce-react to v3.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5920`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6e21220d69edfb091b18a80c38e361f1f54529be",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6e21220`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.28 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5892",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5892`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6c6e0775ff0fa420beee941b3efa01e7e6fb0c84",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6c6e077`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.8.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5904",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5904`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6ae4e159733a250ddd0dfbc2114f3e0f3a658b24",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6ae4e15`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.21.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5926",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5926`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/165782a42d6f7dda46cc4d8af6104e252dc35a3e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`165782a`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-27",
        "aria-label": "features 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` adds story for links (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5951",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5951`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/64eef991d4c795a4decd379d687196d8ecfb5705",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`64eef99`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` allow Link to be used without href prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5927",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5927`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cac7a28ca868c402bea299432cc6f28e10ef99c2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cac7a28`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` story for input field (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5929",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5929`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0017ab99d31393c3dd5078b70c8858e9e41e5066",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0017ab9`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1831]`}{` Contact Item component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5631",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5631`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1f23d68c60242f6ad78b7e898be4f7d03d1504de",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1f23d68`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "860-2020-02-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#860-2020-02-18",
        "aria-label": "860 2020 02 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.5.3...v8.6.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.6.0`}</a>{` (2020-02-18)`}</h2>
    <h3 {...{
      "id": "bug-fixes-32",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-32",
        "aria-label": "bug fixes 32 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`type fix for EmptyState (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5852",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5852`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ea0e00bd276b8306916643066793c8e21ce7427e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ea0e00b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.27 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5822",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5822`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b518e80e74dfe15fe19085fdfd42f8df2d498f9a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b518e80`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-plugin-react-hooks to v2.4.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5861",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5861`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a4ccaf5e7bf281d33fa4eb945300ed37134c2973",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a4ccaf5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.19.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5829",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5829`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/165794944fc3a232742a54a75558ee6a2387d418",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1657949`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.20.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5859",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5859`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/75c579c042042a8445d1f4a0d69a085af525d462",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`75c579c`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-28",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-28",
        "aria-label": "features 28 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`dropdown component in storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5813",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5813`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/54a0a974a5557635e023355e153410375849d4b3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`54a0a97`}</a>{`)`}</li>
      <li parentName="ul">{`WXP Detail Page Layout (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5814",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5814`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aa594ff5e95d138602fc2f587c281950cabdf59d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aa594ff`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "852-2020-02-06",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#852-2020-02-06",
        "aria-label": "852 2020 02 06 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.5.1...v8.5.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.5.2`}</a>{` (2020-02-06)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "850-2020-02-06",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#850-2020-02-06",
        "aria-label": "850 2020 02 06 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.4.0...v8.5.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.5.0`}</a>{` (2020-02-06)`}</h2>
    <h3 {...{
      "id": "bug-fixes-33",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-33",
        "aria-label": "bug fixes 33 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`make tokenRenderer optional (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2fa9ecc52643e5d5ed1826be1fd34a692b049cf2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2fa9ecc`}</a>{`)`}</li>
      <li parentName="ul">{`review comments (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fabe403d71584962dd8a24616e23478f718a5bd9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fabe403`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-29",
        "aria-label": "features 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`add getGroup (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f74f69344556f8b68c3f12b215e212b691432663",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f74f693`}</a>{`)`}</li>
      <li parentName="ul">{`add multiselect custom groups docs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/51d41fc8aa69b117a5f541e23182b883b0fb0774",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`51d41fc`}</a>{`)`}</li>
      <li parentName="ul">{`add multiselect groups (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/01c5b366efc7488ed6057a00e7bac10ab11f0523",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`01c5b36`}</a>{`)`}</li>
      <li parentName="ul">{`add tokenRenderer (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/341d3481a24b85ffa625516e81387117d8819a0b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`341d348`}</a>{`)`}</li>
      <li parentName="ul">{`make groups optional (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5ee3610cfd96ede20d1997aebaede9155a804756",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5ee3610`}</a>{`)`}</li>
      <li parentName="ul">{`post-merge fix (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6bdb06c1e1589d8760949a0706fe4423c056509d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6bdb06c`}</a>{`)`}</li>
      <li parentName="ul">{`remove redundant code, prevent error if group is not found (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/685f5a9330c942f917712b52e10b4fd669e224f6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`685f5a9`}</a>{`)`}</li>
      <li parentName="ul">{`rename groups to optgroups, add roadmap and deprecation warnings (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2cfa349d46937674b78b3f0ba6165c8aed872c5f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2cfa349`}</a>{`)`}</li>
      <li parentName="ul">{`rename Option and Group interfaces (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/211cbfa06b81df13d52ef35bcd2a2665bd822a2b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`211cbfa`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "840-2020-02-06",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#840-2020-02-06",
        "aria-label": "840 2020 02 06 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.3.0...v8.4.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.4.0`}</a>{` (2020-02-06)`}</h2>
    <h3 {...{
      "id": "bug-fixes-34",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-34",
        "aria-label": "bug fixes 34 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`append value to path onChange (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5750",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5750`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0399a297124d671cb316cf46c570e8354abe6f64",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0399a29`}</a>{`)`}</li>
      <li parentName="ul">{`extend MenuProps typespec to include style prop (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5756",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5756`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8e84c51379ba91d647da4669661d3ef5ce4381bc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8e84c51`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update babel monorepo to v7.8.4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5694",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5694`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/867e8795e3f9ba8490ac0e6d095134f5aff6d8dc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`867e879`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @tinymce/tinymce-react to v3.4.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5716",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5716`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/62da997349af28828eccd70ca66c0cd066697423",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`62da997`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.26 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5678",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5678`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8cf70d442233dd95d679d6f2ce3d3cf82f67fb81",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8cf70d4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.10.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5670",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5670`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/09a84af75b69f4d866ece4b0e2d6f35e11151f5a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`09a84af`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency ramda to v0.27.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5734",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5734`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7057def0b57c29ea9eedf155421b0fb3c9f2f26b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7057def`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update jest monorepo to v25 (major) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5628",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5628`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/66d5ba212a12924d10f26803e36e84d8dc25cb63",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`66d5ba2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.19.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5748",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5748`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0c04befca29ab8246912dab918dd81b5319af965",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0c04bef`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1941]`}{` removing tabs never cleaned up bugfix (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5665",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5665`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/93224b1be201381becb9d967013465c0d691ccfb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`93224b1`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-30",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-30",
        "aria-label": "features 30 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1940]`}{` Table Font Size (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5668",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5668`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5cecb693ae7d97981e70ad19ea9ae806da689a43",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5cecb69`}</a>{`)`}</li>
      <li parentName="ul">{`Expose Overlaytrigger Lifecycle Methods for DateSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5691",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5691`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4bdca4e1ac97fd92fc5958396f31fae40e784d6c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4bdca4e`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "830-2020-01-27",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#830-2020-01-27",
        "aria-label": "830 2020 01 27 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.2.1...v8.3.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.3.0`}</a>{` (2020-01-27)`}</h2>
    <h3 {...{
      "id": "bug-fixes-35",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-35",
        "aria-label": "bug fixes 35 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` textEditor bug fix (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/df4acdca15ab7d01a6fba586573a294f6ddc6af0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`df4acdc`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5636",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5636`}</a></li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.25 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5607",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5607`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dda9ee1e0ef8e7432ba2bdbf31fc25d9cf4e7808",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dda9ee1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency sass-loader to v8.0.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5527",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5527`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a703bd3c991f73885e21208581410acf1be1d6cd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a703bd3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency sass-loader to v8.0.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5543",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5543`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/34b6c59b932a4731568e6f10fc5d4b8c2668e263",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`34b6c59`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.7.5 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5599",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5599`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c90e3f5acb52d1a8f0649855077d3496518528bd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c90e3f5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.16.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5545",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5545`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dc853753baa30a39f999155247ffccb7bc61cf9e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dc85375`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.17.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5615",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5615`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1a640702ff943e58aa410a2499793b312853f4fb",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1a64070`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.18.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5659",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5659`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6e1a2eb2ff3cb913b359390f8b39a75665aeb210",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6e1a2eb`}</a>{`)`}</li>
      <li parentName="ul">{`fix internal search for multiselect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9ca962a0f7bef22eccc1e083a66a73ddcdafbdd5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9ca962a`}</a>{`)`}</li>
      <li parentName="ul">{`fix internal search for multiselect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5583",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5583`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8a66b90c9c63bfea3a46e002086d8c7340d0b369",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8a66b90`}</a>{`)`}</li>
      <li parentName="ul">{`fixes Tabs "More" to be click instead of hover (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/199363456633e9b827f8bf4530dc0d90552d0f35",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1993634`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-31",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-31",
        "aria-label": "features 31 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1824]`}{` Add i18nScope to Dropdown and Select (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5562",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5562`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fe22610378af0bb58912728fa346635691d99e26",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fe22610`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add indeterminate no label (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/24a1184ff6d26cdb57c62c2a169b4e6ea51b4e90",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`24a1184`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add level story to card (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/49d5d2ab953a9cc736f3a0818dc82e5af30f219c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`49d5d2a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add story for calendar component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4b986deed54dbb219138cc732bd1fa90fbd48763",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4b986de`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add story for card (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cda209dc2db8ae1dbe0c2c6ba7788482afa0a56d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cda209d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add story for checkbox (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/85d14518ef2a0764b26ef25c78a135357c209730",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`85d1451`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` fix calendar import (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/086a489272b5b29752efabd49fe467a7748eca3e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`086a489`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` font-family lato works (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7bc64ee05affbd0f6d8a9f73d27cb56b7f89d606",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7bc64ee`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` yarn.lock conflict (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ab42b1582490af18fd9b24416f065018c173d36f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ab42b15`}</a>{`)`}</li>
      <li parentName="ul">{`controlled Search is now possible (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5596",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5596`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f0aa47c48977a624f160e253360946216fa39132",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f0aa47c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` import lato font (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d9fd9c18c0cbd8b1c819a673c930d3ceca11bc41",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d9fd9c1`}</a>{`)`}</li>
      <li parentName="ul">{`setup percy for storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5535",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5535`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/63cf8c36c03760b66548542a954b8d100fe312dc",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`63cf8c3`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "821-2020-01-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#821-2020-01-09",
        "aria-label": "821 2020 01 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.2.0...v8.2.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.2.1`}</a>{` (2020-01-09)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "820-2020-01-09",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#820-2020-01-09",
        "aria-label": "820 2020 01 09 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.1.0...v8.2.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.2.0`}</a>{` (2020-01-09)`}</h2>
    <h3 {...{
      "id": "bug-fixes-36",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-36",
        "aria-label": "bug fixes 36 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.15.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5496",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5496`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/69ec45a9b92d14ab8542cfe78dd4f82949b4132d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`69ec45a`}</a>{`)`}</li>
      <li parentName="ul">{`selectableTiers prop doc, spinnerLabel documented (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5500",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5500`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b0447b7f8b6a665a774f530cc3595de2b2f58440",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b0447b7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` fix tsconfig for storybook, hopefully (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/228baf7f6afb9c4b1dd0587e6175f35b4fe9f02e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`228baf7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` localisation for Pagination component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5403",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5403`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3ed11135cb50d9080cb53455ac850d7571e61da9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3ed1113`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update babel monorepo to v7.7.6 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5374",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5374`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/60f754794264c25b518cc5096bef26b0ab45aa0d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`60f7547`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.16 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5377",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5377`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/90e670f3d5f09c80912bfd6c2e377d3be442bbe2",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`90e670f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.17 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5385",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5385`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8bb5a26c1815123e79b209dd53ed43890de0f0ad",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8bb5a26`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.18 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5413",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5413`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5e70f8709e68d4077b87e63040f664a5a5308c1d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5e70f87`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.19 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5425",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5425`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7cea15300519c72eac13a51077c7767b15b93913",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7cea153`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.20 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5428",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5428`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1616ed496d921c435d1743eae72248bafce36eb9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1616ed4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.21 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5435",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5435`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8b22cde499e9264a2cceecabbe4a8adc6f991f1c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8b22cde`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.22 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5466",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5466`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7d5155ade64dcbda35e38dcad8f3a57263edd4e0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7d5155a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency @types/node to v12.12.24 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5490",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5490`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/94760e711dc5f70772c997ac7c21546c32bf5e10",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`94760e7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint to v6.8.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5459",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5459`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fd94903986b5989c6079c5a63a6729dcd28eb622",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fd94903`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.8.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5471",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5471`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d2655928129b62bda5f05dc2e8e609c807503483",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d265592`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.9.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5477",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5477`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fc57bdb352426e9e39ad78925c4ebd147b7ac3ae",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fc57bdb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency i18n-js to v3.5.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5461",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5461`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8b278fa9f4e88ee6e6d1e01ea903124db45c6822",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8b278fa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.7.3 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5354",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5354`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7ac2476fb8b8af4097a6c345d2966de62a73f9da",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7ac2476`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.7.4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5460",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5460`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e1b320ae9e28e8dbd69b030b3e1ccc962c02b240",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e1b320a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.11.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5380",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5380`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7d27447c400b078ad1911032b579069d9ec1e21b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7d27447`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.12.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5416",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5416`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5dc74c59ba645b43a5c1ac0b127b50bb2af8005a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5dc74c5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.13.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5468",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5468`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e5e167829ee0e5d99077cc89423d2b3c4c5d9e9f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e5e1678`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.14.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5483",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5483`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ad5fdfd072878eb2fe1c380cb3d900533d2106b0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ad5fdfd`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1801]`}{` Checkbox No Paragraph Tag (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5351",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5351`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/040b4764afd9b2afbd1a93f3b164628eca9cfaab",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`040b476`}</a>{`)`}</li>
      <li parentName="ul">{`fixing I18n and specs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5340",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5340`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aacd1439ba33fec4609235d5eec01ce637e34cf7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aacd143`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-32",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-32",
        "aria-label": "features 32 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1805]`}{` Add a @procore/core-i18n-js package (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5441",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5441`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/34ffaa56639bec69a61955b374c99460876bcd22",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`34ffaa5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` breadcrumbs stories & TEXT export (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b3d7ed1e9b972041149b527551e1a8626b085e29",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b3d7ed1`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1803]`}{` Error boolean prop for Input, TextArea, DateInput, DateSelect (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5350",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5350`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/42a8a6c52b161373df0604942e2bfae1a9c4f9e8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`42a8a6c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` add storybook avatar test (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5d890b1130ac1fb0f889beebf82c3be4e2632137",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5d890b1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` adds avatar tests (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4a4d1dcd8113e09a2036b6cb2d24f7f7001d53e6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4a4d1dc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` first full pass for button in storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/01a76ef6f074b2704a19dae66f9ec27702d69223",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`01a76ef`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` more avatar tests (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6808becc09d595b9aee1125bbada13d765930d3b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6808bec`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` remove some duplicate cases (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5fb6dff49e70401a592ee400063145302e7821b7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5fb6dff`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` resolved merge conflict (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ddf861fb7cdd994f969006263c026233d2a137a8",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ddf861f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` setup storybook on core-react (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b47ab3a3506c82ed46193a609e85ad2cfbf83887",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b47ab3a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` simple breadcrumb test (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/76f25bafeeae89aee6f2401383ca91008e580d98",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`76f25ba`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` stories for banner storybook (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/be653822cc816f3d6c89a25069ead4340f0c661e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`be65382`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` storybook for banner component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0d36e758b82b52aa1578af63b936255bcf36fdda",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0d36e75`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` yarn-lock (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/520bcc2553659b44903c9c773e77199eb7e6d533",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`520bcc2`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1522]`}{` Docs v2 gatsby mdx (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5252",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5252`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6ad044a797d7a653902dd57374bcacfd023d6425",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6ad044a`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "reverts-4",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#reverts-4",
        "aria-label": "reverts 4 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Reverts`}</h3>
    <ul>
      <li parentName="ul">{`reverts the work done on modal to allow it to scroll again (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5355",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5355`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/90bb9fde838908b49fad46ec8587ca8b2f462f39",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`90bb9fd`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "810-2019-12-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#810-2019-12-03",
        "aria-label": "810 2019 12 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.0.1...v8.1.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.1.0`}</a>{` (2019-12-03)`}</h2>
    <h3 {...{
      "id": "bug-fixes-37",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-37",
        "aria-label": "bug fixes 37 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` explicit w\\ null arg (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2da07f6c0aa904f64868740a0ac58790ad047d51",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2da07f6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint to v6.7.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5330",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5330`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3653012f9642c74e3061b1f29a8e8c855ec94d8e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3653012`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.10.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5335",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5335`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3b9b1b6aafa8a0a440d380794244e4d9d494e76b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3b9b1b6`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1786]`}{` re-allow custom t function from custom i18n object (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5290",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5290`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/d0342b58c982bd0eeadd07d70dd60893ed91eef6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`d0342b5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`core-react:`}</strong>{` createRef -> useRef change (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/879a48a7b2d5171e94049d3bcf52ec9bdf0a6544",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`879a48a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint to v6.7.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5298",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5298`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/aac3e511b539822fd4d41b2bc8526379155c7453",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`aac3e51`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint to v6.7.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5307",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5307`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e4f066a1f31631aa08a152284dca0542ec08d9c7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e4f066a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.7.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5271",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5271`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/545714046d9af334e61ec227a3fe967826c68d06",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5457140`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.8.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5270",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5270`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/bf59eadd74e7a8d7ddf96d9833b55de8721de97f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`bf59ead`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.9.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5311",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5311`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/8b8e1e7d3fd9dcebab9260ec9919197fa17f64b3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`8b8e1e7`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-33",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-33",
        "aria-label": "features 33 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-818]`}{` Inline Editable Datepicker Cell (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4992",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4992`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1f855216dd26f677a3429eb2286f2df337ac9ef6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1f85521`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "801-2019-11-18",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#801-2019-11-18",
        "aria-label": "801 2019 11 18 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v8.0.0...v8.0.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.0.1`}</a>{` (2019-11-18)`}</h2>
    <h3 {...{
      "id": "bug-fixes-38",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-38",
        "aria-label": "bug fixes 38 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`add core-icons as a dep to core-react (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5262",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5262`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/42f64635564e9e9a020527327957e20ab877581d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`42f6463`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.6.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5256",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5256`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/04d3457453776378aeec86daad06447b37fd6ff5",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`04d3457`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "800-2019-11-15",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#800-2019-11-15",
        "aria-label": "800 2019 11 15 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.21.3...v8.0.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`8.0.0`}</a>{` (2019-11-15)`}</h2>
    <h3 {...{
      "id": "bug-fixes-39",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-39",
        "aria-label": "bug fixes 39 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`i18n provider args and copy i18njs into new object (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5242",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5242`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/48764e525010ca2312320fbd0e861c391a1dbcda",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`48764e5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update babel monorepo to v7.7.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5180",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5180`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/dba58dcc41de30790e5e7ccb20df964334c5f757",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`dba58dc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency eslint-config-prettier to v6.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5122",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5122`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a87ec1f6d0c4365df1b356e3f0496cee1ecb504a",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a87ec1f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency ts-loader to v6.2.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5104",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5104`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ab67f4c2062b7ec3b81021470937a7e021eb42de",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ab67f4c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update react monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5243",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5243`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2ef7879234499aa8e792b0d619fdd5e6a273e618",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2ef7879`}</a>{`)`}</li>
      <li parentName="ul">{`change target back to es5 so ie works again (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5227",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5227`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9fcb5001fc2dfb3d5d33d61386cbadf28820ae79",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9fcb500`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency i18n-js to v3.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5220",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5220`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/4d5ad9c2155867d872aa19784b857e14cc2996a7",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`4d5ad9c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update react monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5097",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5097`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ee4086eec3721cf6f952f3a0025092c30d8a3d37",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ee4086e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.5.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5088",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5088`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6c4768be001b1d2fcf309d66b3a1263f4e28cb80",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6c4768b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.6.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5126",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5126`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f5e931438224741146b26479e136ccf5951ca230",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f5e9314`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.7.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5208",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5208`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a5eee4953a7c29e5b546e9f9d655e0278912c08f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a5eee49`}</a>{`)`}</li>
      <li parentName="ul">{`removes getId getLabel spread onto dom (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5175",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5175`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2dd4f7ec97f647230970a9ccfe041be7dfec8834",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2dd4f7e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.7.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5166",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5166`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f33feffb394c1c728b242d39751e07b8b49a487e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f33feff`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update typescript-eslint monorepo to v2.6.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5159",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5159`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c3f044348e0007867c7f6c3edf5a58bfec7b1160",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c3f0443`}</a>{`)`}</li>
      <li parentName="ul">{`explicitly list core-icons as a dep, add sideEffects: false (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5075",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5075`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/2d8437d525066f60c64c2daf2da052bee9d8740e",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2d8437d`}</a>{`)`}</li>
      <li parentName="ul">{`fix types for banner dismiss button (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5065",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5065`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b5be16a6b00c43c013a6bdd7748548a79b884a71",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b5be16a`}</a>{`)`}</li>
      <li parentName="ul">{`icons are not focusable (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5090",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5090`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/78d642257c9578b004dbd82c5f72ee4a0d4f59b9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`78d6422`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4896",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4896`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4902",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4902`}</a></li>
      <li parentName="ul">{`modal id is generated from time instead of ulid (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5076",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5076`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fd5693f1ab6a45b68c4f52f9851fb29831de3797",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fd5693f`}</a>{`)`}</li>
      <li parentName="ul">{`removing the core- prefix that is no longer used (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5093",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5093`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e864ea7cc3677adec53d55558c78fe6502f0a300",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e864ea7`}</a>{`)`}</li>
      <li parentName="ul">{`use svg icons for modal, toast, and pagination (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/02ab7f8a7b564613bab5c653ba8492b28ea622a4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`02ab7f8`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "chore-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#chore-1",
        "aria-label": "chore 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`chore`}</h3>
    <ul>
      <li parentName="ul">{`write core-react into the dist folder instead of lib (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5191",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5191`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/3b8e863fe32d7c2b4e5eb1207c51a0938084b0c6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`3b8e863`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-34",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-34",
        "aria-label": "features 34 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1531]`}{` using i18n-js with phrase for default translations in core (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5119",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5119`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/6840a622644179e0273b95a3040c0fdaa9beb7b0",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`6840a62`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1568]`}{` Switch to ESM build (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4945",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4945`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b6195f83c8368a878d2d0afe7c32087a6545c9dd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b6195f8`}</a>{`)`}</li>
      <li parentName="ul">{`Cleanup of tabs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5161",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5161`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/cf975a7d0ea2be494652c28d6d5c7b41d4d772e6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`cf975a7`}</a>{`)`}</li>
      <li parentName="ul">{`Dynamic contents and dark mode for Tabs (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5102",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5102`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/451f3c17f882f45c454ef5b19d8e8c09b9f75850",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`451f3c1`}</a>{`)`}</li>
      <li parentName="ul">{`Icon renders SVG paths (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5003",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5003`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fb3b90c6b4981732ff0fbb057f7240b7e3dddca4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fb3b90c`}</a>{`)`}</li>
      <li parentName="ul">{`updated translations from Phrase (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5238",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5238`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/1aa348bb445ba0dd4e0b9a78dbb022dceabd638c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`1aa348b`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "breaking-changes-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#breaking-changes-1",
        "aria-label": "breaking changes 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`BREAKING CHANGES`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`rename /lib/ output to /dist/`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`removing webpack/lib builds`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`fix: resolve bind type declaration for tests`}</p>
      </li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`chore: remove unused babelrc`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <ul>
      <li parentName="ul">{`feat: fix TieredSelect classnames import and run regression`}</li>
    </ul>
    <p>{`affects: @procore/core-react`}</p>
    <h2 {...{
      "id": "7213-2019-11-11",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#7213-2019-11-11",
        "aria-label": "7213 2019 11 11 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.21.2...v7.21.3",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`7.21.3`}</a>{` (2019-11-11)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "7212-2019-10-29",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#7212-2019-10-29",
        "aria-label": "7212 2019 10 29 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.21.1...v7.21.2",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`7.21.2`}</a>{` (2019-10-29)`}</h2>
    <h3 {...{
      "id": "bug-fixes-40",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-40",
        "aria-label": "bug fixes 40 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1760/multiselect]`}{` filter new options (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5118",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5118`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/63d3858d4d6a13d158c279c474fdc625fb0209a6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`63d3858`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "7211-2019-10-17",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#7211-2019-10-17",
        "aria-label": "7211 2019 10 17 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.21.0...v7.21.1",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`7.21.1`}</a>{` (2019-10-17)`}</h2>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @procore/core-react`}</p>
    <h2 {...{
      "id": "7210-2019-10-16",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#7210-2019-10-16",
        "aria-label": "7210 2019 10 16 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.20.0...v7.21.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`7.21.0`}</a>{` (2019-10-16)`}</h2>
    <h3 {...{
      "id": "bug-fixes-41",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-41",
        "aria-label": "bug fixes 41 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`cancel overlay trigger timers correctly (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5040",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5040`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/0f190e8a922267177f75e08d5cda26fd8e9fe409",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`0f190e8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency webpack to v4.41.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5044",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5044`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/b63fa862bcaeb7346a20c1b876957c9bf57a4a53",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`b63fa86`}</a>{`)`}</li>
      <li parentName="ul">{`placeholder prop is now respected (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5030",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5030`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/ff6d961a1c7f83d8b2f5b9b92b8bec11708bbfef",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`ff6d961`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency typescript to v3.6.4 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5013",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5013`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9667f02e16eb0c8a80dac295f11a26bee313df18",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9667f02`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency webpack to v4.41.1 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5024",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5024`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/79dff2aa76d09306d9d0d4de944f093dba062a1d",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`79dff2a`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-35",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-35",
        "aria-label": "features 35 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`[GLUE-1747]`}{` tiered select component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4903",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4903`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/13b330cdcd4f686f3f2b8a52d2e652c9e4f9f8e9",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`13b330c`}</a>{`)`}</li>
      <li parentName="ul">{`[React]`}{` Multiselect onFocus and onBlur Types (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4994",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4994`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/7ca3370f7376900410d0bd1be25fa3cc198c0746",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`7ca3370`}</a>{`)`}</li>
      <li parentName="ul">{`disable body scroll when modal is open (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4976",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4976`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/590a391320e14fff968f74230bd1673639e6dfd6",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`590a391`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4896",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4896`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4896",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4896`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4896",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4896`}</a></li>
      <li parentName="ul">{`swap table icons to Icon component (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/5056",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#5056`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/5886ee2d173f484d342d5672b131c5086f37dd15",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`5886ee2`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "7200-2019-10-03",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#7200-2019-10-03",
        "aria-label": "7200 2019 10 03 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><a parentName="h2" {...{
        "href": "https://github.com/procore/core/compare/v7.19.0...v7.20.0",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`7.20.0`}</a>{` (2019-10-03)`}</h2>
    <h3 {...{
      "id": "bug-fixes-42",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bug-fixes-42",
        "aria-label": "bug fixes 42 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bug Fixes`}</h3>
    <ul>
      <li parentName="ul">{`enable Tab when a MultiSelect token is selected (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4940",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4940`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/9b1c828",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`9b1c828`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency ts-loader to v6.2.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4935",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4935`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/c06c47b",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`c06c47b`}</a>{`)`}</li>
      <li parentName="ul">{`[GLUE-1736]`}{` consume zindex in portal (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4910",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4910`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/45e4b8c",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`45e4b8c`}</a>{`)`}</li>
      <li parentName="ul">{`fix the select clear icon showing when it shouldn't (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4920",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4920`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e97abd4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e97abd4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency ts-loader to v6.1.2 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4880",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4880`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/fb78c1f",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`fb78c1f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`deps:`}</strong>{` update dependency webpack to v4.41.0 (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4890",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4890`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e727ab3",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e727ab3`}</a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "features-36",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#features-36",
        "aria-label": "features 36 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`add pseudo locale to Locale type (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/f0633e4",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`f0633e4`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4918",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4918`}</a></li>
      <li parentName="ul">{`consume newly uploaded pseudo.js language file for TextEditor (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4958",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4958`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/a571cdd",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`a571cdd`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4918",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4918`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4918",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4918`}</a></li>
      <li parentName="ul">{`synchronize listNavigation index with Option mouse events (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/issues/4949",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`#4949`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/procore/core/commit/e30ed86",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`e30ed86`}</a>{`)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      